export default class formConfig {
  // 区管划分
  static configList() {
    return [
      {
        title: "系统配置表详情",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "类型：",
            type: "select",
            value: "type",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202008061609580003",
            },
            rule: {
              required: true,
              message: "请选择类型",
              trigger: "blur"
            }
          },
          {
            label: "区管：",
            type: "select",
            value: "competentDepart",
            placeholder: "请输入",
            queryParams: {
              url: "/zoneCode/TradeCenterCombobox",
            },
            rule: {
              required: true,
              message: "请选择区管",
              trigger: "blur"
            }
          },
          {
            label: "内容：",
            type: "textarea",
            value: "content",
            required: true,
            maxlength: 500,
            minRows: "3",
            maxRows: "2",
            rule: {
              required: true,
              message: "请填写内容",
              trigger: "blur"
            }
          },
          {
            label: "备注：",
            type: "textarea",
            value: "remarks",
            required: true,
            maxlength: 500,
            minRows: "3",
            maxRows: "2",
          },
          {
            label: "是否默认项：",
            type: "radio",
            value: "isDefault",
            required: true,
            rule: {
              required: true,
              message: "请选择是否默认项",
              trigger: "blur"
            },
            option: [
              {
                label: "是",
                value: "01"
              },
              {
                label: "否",
                value: "02"
              }
            ]
          },
        ]
      },
    ];
  }
}
